import React from 'react'

type PropsType = {
  //
}

export const Divider: React.FC<PropsType> = () => (
  <li className="dropcart__divider" role="presentation" />
)
